<script>
import GoalIndicator from '@companies/components/goal-indicator.vue'
export default {
  name: 'UserProfile',
  components: {
    GoalIndicator,
  },
  props: { user: { type: Object, required: true } },
  data() {
    return {}
  },
  computed: {
    goalFontSize() {
      let maxLength = 0
      let fontSize = 'text-4.5xl'
      for (var i = this.user.goals.length - 1; i >= 0; i--) {
        if (this.user.goals[i].achieved.toString().length > maxLength) {
          maxLength = this.user.goals[i].achieved.toString().length
        }
      }
      if (maxLength > 4) {
        fontSize = 'text-3xl'
      }
      return fontSize
    },
  },
  methods: {},
}
</script>

<template>
  <BaseModalWindow
    modalcls="user-profile w-full max-w-1.95xl bg-white rounded-xl ml-15 px-10 py-8 shadow-box relative left-0"
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <div class="flex border-b border-gray pb-6 mb-8">
        <img
          :src="user.image_url"
          class="mr-7.5 rounded-full h-28 w-28 inline-block"
          :alt="user.name"
        />
        <div class="leading-2lg">
          <div class="mb-5">
            <a class="text-blue-darker text-5.5xl mr-3.5">{{ user.name }}</a>
            <span class="text-gray-light text-lg font-hairline"
              >Denver, CO</span
            >
          </div>
          <div class="">
            <router-link
              :to="{ name: 'user-page', params: { userId: user.id } }"
              class="button primary-button inline-block"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="24"
                viewBox="0 0 21.609 23.697"
                class="inline-block align-text-bottom mr-3"
              >
                <g
                  id="Group_118"
                  data-name="Group 118"
                  transform="translate(-48.129 26.609)"
                >
                  <g
                    id="Group_116"
                    data-name="Group 116"
                    transform="translate(52.571 -26.609)"
                  >
                    <path
                      id="Path_64"
                      data-name="Path 64"
                      d="M57.815-13.854a6.384,6.384,0,0,1-6.378-6.378,6.384,6.384,0,0,1,6.378-6.378,6.384,6.384,0,0,1,6.378,6.378A6.385,6.385,0,0,1,57.815-13.854Zm0-11.413a5.04,5.04,0,0,0-5.035,5.035A5.041,5.041,0,0,0,57.815-15.2a5.042,5.042,0,0,0,5.035-5.035A5.041,5.041,0,0,0,57.815-25.266Z"
                      transform="translate(-51.437 26.609)"
                      fill="#f4fbfc"
                    ></path>
                  </g>
                  <g
                    id="Group_117"
                    data-name="Group 117"
                    transform="translate(48.129 -13.473)"
                  >
                    <path
                      id="Path_65"
                      data-name="Path 65"
                      d="M68.421-6.265H49.445a1.4,1.4,0,0,1-1.316-1.49c0-4.521,2.763-8.412,6.426-9.054a1.183,1.183,0,0,1,.965.278A5.357,5.357,0,0,0,58.907-15.1a8.245,8.245,0,0,0,3.469-1.4,1.233,1.233,0,0,1,.979-.274c3.664.616,6.409,4.5,6.383,9.03A1.4,1.4,0,0,1,68.421-6.265ZM54.755-15.6c-3.087.52-5.423,3.9-5.423,7.845,0,.187.085.285.113.285H68.421c.024,0,.113-.087.113-.285.021-3.946-2.284-7.31-5.364-7.835A9.283,9.283,0,0,1,58.935-13.9,6.343,6.343,0,0,1,54.755-15.6Z"
                      transform="translate(-48.129 16.825)"
                      fill="#f4fbfc"
                    ></path>
                  </g>
                </g>
              </svg>
              View Full Profile</router-link
            >
          </div>
        </div>
      </div>
      <div class="text-xl text-gray">
        <!-- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce felis
        lectus. Aenean consectetur augue lorem, et eleifend dui commodo ut. Ut
        vel scelerisque ex, quis finibus est. -->
      </div>
      <div class="mt-5 flex">
        <GoalIndicator
          v-for="goal in user.goals"
          :key="goal.type"
          :goal="goal"
          :font-size="goalFontSize"
        ></GoalIndicator>
      </div>
    </template>
  </BaseModalWindow>
</template>
